// extracted by mini-css-extract-plugin
module.exports = {"block":"select-tags-popup_block__3kQI6","s-text":"select-tags-popup_s-text__3KeE2"};